const SearchIcon = ({ width, height, color }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M6.84823 11.168C9.39316 11.168 11.4562 9.10496 11.4562 6.56003C11.4562 4.0151 9.39316 1.95203 6.84823 1.95203C4.30331 1.95203 2.24023 4.0151 2.24023 6.56003C2.24023 9.10496 4.30331 11.168 6.84823 11.168Z'
        stroke={color}
        strokeMiterlimit='10'
        strokeLinecap='round'
      />
      <path
        d='M10.082 10.082L13.9041 13.9041'
        stroke={color}
        strokeMiterlimit='10'
      />
    </svg>
  );
};

export default SearchIcon;
